/**
 * 成本预算编辑器
 *
 */

'use strict'

import Vue from 'vue';
import Component from "vue-class-component";
import { iStorage, iValidator } from 'smart-core-util';
import { budgetValidator } from '@scripts/validators/budgetValidator.js';

@Component
class budgetEditor extends Vue {

	validator = budgetValidator;

	budgetForm = {
		itemName: "", //预算项目
		serviceType: "", //服务类型
		// mettingType: "", //会议室类型
		amount: "", //预算金额
		descr: "", //备注
		peopleNum: "", //人数
		// meetingNum: 1, //场次
		days: "", //天数
		startDate: '', //开始日期
		endDate: '', //结束日期
	}
	validModel = {}
	eventSize= ''
	budgetList = [];

	get proposalId() {
		return iStorage.get("proposalId");//存在加载先后顺序问题,导致获取的可能是之前的id TODO
	}

	async created() {
		this.getBudget();//移动至此,存在执行顺序问题
		await this.getBudgetItem();
	}

	//计算服务费
	getAmount() {
		switch(this.budgetForm.serviceType) {
			case "前期人员":
				this.amountSum = this.formatMoney(
					Number(this.Amount(this.beforeCharge)) *
					Number(this.budgetForm.peopleNum) *
					Number(this.budgetForm.days)
				);
				break;
			case "现场人员":
				this.amountSum = this.formatMoney(
					Number(this.Amount(this.middleCharge)) *
					Number(this.budgetForm.peopleNum) *
					Number(this.budgetForm.days)
				);
				break;
		}
	}
	getMeetingAmount () {
		this.meetingTypeList.forEach(item => {
			if (item.mettingTypeDesc === this.budgetForm.mettingType) {
				this.meetingAmount = parseFloat(item.amount)
			}
		})
	}
	//获取预算项目
	async getBudgetItem() {
		let miceInfo;
		if('customOrigin' in this && this.customOrigin == "web") {
			miceInfo = this.iStorage.get('model')
		} else {
			miceInfo = iStorage.get("eventMsg")
		}
		const {
			typeDictVal,
			provinceDictVal
        } = miceInfo;
        const {
            eventSize,
			vMettingType
        } = miceInfo.itsExtData;
		this.eventSize = eventSize
		var params = {
			"collection": "cfg-ievent-category",
			"useCaching": false,
			"cachingKey": "",
			'filter': {
				'$and' : [
					{"config.eventSize" : eventSize || "level1" },
					{"config.eventType" : typeDictVal}
					]
			},
			"projection": {
				"project": 1,
				"itsExtData": 1
			},
			"sort": {
				"sort": 1
			},
            "limit": 100
		};
		var response = await this.api.post(this.url.mice.GetBudgetProjects, params);
		if(response && response.success) {
			this.budgetList = response.content.filter(ele => {
				if (vMettingType) {
					return ele
				} else {
					return !["视频会议"].includes(ele.project)
				}
			});
			this.itsExtData = response.content.forEach(ele => {
				if (ele.project == "上会服务人员服务费"&& this.eventSize != 'level2') {
					this.beforeCharge = this.formatMoney(ele.itsExtData.beforeCharge);
					this.middleCharge = this.formatMoney(ele.itsExtData.middleCharge);
					this.hintList.push({type: '上会服务人员服务费', tips: ele.itsExtData.tips})
				}
				if (ele.project == "视频会议") {
					this.hintList.push({type: '视频会议', tips: ele.itsExtData.tips || ''})
				}
			});
			//编辑,先请求完数据再exit
			if(this.isEdit) {
				this.budgetForm.itemName = iStorage.get("budgetItem").itemName;
				this.budgetForm.descr = iStorage.get("budgetItem").descr; //备注
				if(this.budgetForm.itemName != "上会服务人员服务费" || this.eventSize == 'level2') {
					this.budgetForm.amount = iStorage.get("budgetItem").amount ? Number(this.Amount(iStorage.get("budgetItem").amount)) : null; //预算金额
				}
				// if(this.budgetForm.itemName == "视频会议") {
				// 	this.budgetForm.meetingNum = iStorage.get("budgetItem").qty
				// 	this.budgetForm.mettingType = JSON.parse(iStorage.get("budgetItem").extData).name
				// 	this.meetingAmount = JSON.parse(iStorage.get("budgetItem").extData).price
				// }
			}
		}
	};

	async saveAsync({
						onSuccess,
						toast,
						$messageError,
						type
					}) {
		if(!new iValidator().validate({
				model: this.budgetForm,
				validator: this.validator,
				toast: toast
			})) {
		        this.canSave = true;
		        return;
		    }
		var params = {
			miceId: this.proposalId, // this.iStorage.get("proposalId"), //会议id
			itemName: this.budgetForm.itemName //预算项目名称
		};

		let budgetItem = iStorage.get("budgetItem")
		if(budgetItem && budgetItem.itemName && ( ['机票/火车票','大巴票'].includes(budgetItem.itemName) || budgetItem.itemName.indexOf('平台用车') > -1)
			&& Number(this.budgetForm.amount) > Number(budgetItem.budgetAmount)) {
			toast && toast("报价金额不能超过预算金额");
			$messageError && $messageError("报价金额不能超过预算金额");
			this.canSave = true;
			return
		}

		//编辑状态
		if(this.isEdit || this.isSrviceStaff || this.editServiceStaff) {
			if (this.iStorage.get("budgetItem").budgetId) {
				params.budgetId = this.iStorage.get("budgetItem").budgetId //预算项目id
			}
			params.budgetType = this.iStorage.get("budgetItem").budgetType; //预算项目
		}
		let pattern = /^[\u4E00-\u9FA5A-Za-z0-9_，。,.（）():%@#]+$/
		if (this.budgetForm.descr && !pattern.test(this.budgetForm.descr)) {
			toast && toast("备注不能包含特殊字符");
			$messageError && $messageError("备注不能包含特殊字符");
			this.canSave = true;
			return;
		}

		if(this.budgetForm.itemName == "上会服务人员服务费" && this.eventSize != "level2") {
			var peopoleExpense = [];
			if(this.addServiceStaff) {
				//详情添加预算入口
				var budgetItemList = this.iStorage
					.get("budgetItemList")
					.filter(ele => {
						return ele.itemName == "上会服务人员服务费";
					});
				if(
					budgetItemList.length > 0 &&
					budgetItemList[0].itsExtData &&
					budgetItemList[0].itsExtData.peopoleExpense &&
					budgetItemList[0].itsExtData.peopoleExpense.length > 0
				) {
					peopoleExpense = budgetItemList[0].itsExtData.peopoleExpense;
					params.budgetId = budgetItemList[0].budgetId;
				}
			} else {
				//编辑上会服务人员入口
				peopoleExpense = this.iStorage.get("serviceList") || [];
			}

			if(this.editServiceStaff) {
				let index = (type && type == 'web') ? Number(this.budgetForm.index) : Number(this.$route.query.index)
				peopoleExpense.splice(index, 1); //编辑的时候替换
				peopoleExpense.map(ele => {
					ele.amount = this.Amount(ele.amount);
				});
			}
			peopoleExpense.push({
				name: this.budgetForm.serviceType, //服务类型
				qty: this.budgetForm.peopleNum, //人数
				price: this.budgetForm.serviceType == "前期人员" ? this.Amount(this.beforeCharge) : this.Amount(this.middleCharge),//单价
                    // this.itsExtData.beforeCharge :
                    // this.itsExtData.middleCharge,
				startDate: this.budgetForm.startDate,
				endDate: this.budgetForm.endDate,
				day: this.budgetForm.days, //天数
				amount: this.Amount(this.amountSum), //金额
				descr: this.budgetForm.descr //备注
			});
			params.qty = 0;
			params.amount = 0;
			peopoleExpense.map(ele => {
				ele.amount = this.Amount(ele.amount);
				params.qty += Number(ele.qty);
				params.amount += Number(ele.amount);
			});
			//TODO
			var _budgetItem = this.iStorage.get("budgetItem");
			var extData = {
				peopoleExpense:peopoleExpense
			};
			if(_budgetItem && _budgetItem.itsExtData && _budgetItem.itsExtData.budgetDict){
				extData.budgetDict = _budgetItem.itsExtData.budgetDict;
			}
			params.extData = JSON.stringify(extData) //前期人员、现场人员
		} else if (this.budgetForm.itemName == "视频会议") {
			// params.qty = Number(this.budgetForm.meetingNum)
			// params.amount = this.meetingAmount * this.budgetForm.meetingNum
			// let extData = {
			// 	name: this.budgetForm.mettingType,
			// 	qty: Number(this.budgetForm.meetingNum),
			// 	price: this.meetingAmount,
			// 	amount: this.meetingAmount * this.budgetForm.meetingNum
			// }
			// params.extData = JSON.stringify(extData)
            params.amount = this.budgetForm.amount;
            params.descr = this.budgetForm.descr;
		} else {
			params.amount = this.budgetForm.amount;
			params.descr = this.budgetForm.descr;
		}
		//讲课费
		if(this.hasSpeaker || (this.$route.query.hasSpeaker && JSON.parse(this.$route.query.hasSpeaker))) {
			params = {
				miceId: this.proposalId, // this.iStorage.get("proposalId"), //会议id
				itemName: this.budgetForm.itemName, //预算项目名称
				amount: this.budgetForm.amount // 预算金额
			};
			if(this.$route.query.item && JSON.parse(this.$route.query.item)) {
				params.budgetId = JSON.parse(this.$route.query.item).budgetId;
			}
            params.descr = this.budgetForm.descr;
		}
		var result = await this.api.post(this.url.budget.save, params); {
			if(result && result.success) {
				onSuccess(result);
			}
		};
	}

}

export default budgetEditor;



// WEBPACK FOOTER //
// ../scripts/components/budgetEditor.js